var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgTree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_21082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_21082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 78.3984C18.5 78.3983 15.8333 92.0651 5 100.898C78.5 143.398 119.5 100.898 112.5 94.8986C105.5 88.8987 98.5 94.8986 93 94.8986C87.5 94.8986 72.9513 78.3985 55 78.3984Z",
    fill: "#A7163E"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_21082)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8143 34.0576L47.931 42.2225L49.3628 45.5196L33.5732 34.5552",
    fill: "#A7163E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2822 19.9556L51.8245 40.9859L54.2607 87.9998H47.2371L49.392 41.2347L44.2822 19.9556Z",
    fill: "#A7163E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3433 14.6053C47.4127 19.4322 39.9836 19.4322 40.0384 14.6053C39.9836 9.79694 47.4127 9.79694 47.3433 14.6053Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7474 12.5781C47.7774 16.5102 42.1892 18.8716 40.1475 15.4557C41.5865 20.9732 49.6877 17.4718 46.7474 12.5781Z",
    fill: "#FF7D23"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8316 20.1044C51.89 24.2852 45.4325 24.2852 45.4946 20.1044C45.4325 15.9235 51.8937 15.9235 51.8316 20.1044Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3171 18.3442C52.212 21.7602 47.3542 23.8135 45.5791 20.8431C46.8282 25.6403 53.8738 22.5956 51.3171 18.3442Z",
    fill: "#FF7D23"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4771 16.8109C55.5355 20.9917 49.078 20.9917 49.1401 16.8109C49.078 12.6301 55.5392 12.6301 55.4771 16.8109Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9616 15.0508C55.8565 18.4667 50.9987 20.52 49.2236 17.5459C50.4728 22.3468 57.5184 19.3022 54.9616 15.0508Z",
    fill: "#FF7D23"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7369 20.1639C46.7114 25.5477 38.6577 25.5477 38.6358 20.1639C38.6139 14.78 46.7114 14.78 46.7369 20.1639Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0753 17.9136C47.2186 22.2801 41.0094 24.9014 38.7412 21.1067C40.341 27.2369 49.3406 23.3494 46.0753 17.9136Z",
    fill: "#FF7D23"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4816 17.4867C42.4561 23.4275 33.5989 23.4275 33.5733 17.4867C33.5477 11.5459 42.4561 11.5645 42.4816 17.4867Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.755 15.0103C43.0151 19.8149 36.1851 22.6999 33.6904 18.5227C35.4473 25.2692 45.3491 20.9919 41.755 15.0103Z",
    fill: "#FF7D23"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1889 15.8269C51.251 20.1006 44.6473 20.1006 44.7094 15.8269C44.6473 11.5681 51.251 11.5681 51.1889 15.8269Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6627 14.041C51.5795 17.5312 46.6121 19.6328 44.7969 16.5956C46.0752 21.5004 53.2742 18.3889 50.6627 14.041Z",
    fill: "#FF7D23"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3488 61.0288L51.4043 72.903L51.565 76.2335L69.3488 61.0288Z",
    fill: "#A7163E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0177 43.9602L51.8242 56.5732L52.0689 61.2739L66.8285 43.0171",
    fill: "#A7163E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9492 46.1919L50.6079 66.2235V62.0167L38.9492 46.1919Z",
    fill: "#A7163E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5566 45.8018L45.0488 55.8046L47.2403 59.7032L31.5566 45.8018Z",
    fill: "#A7163E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.115 43.1543C40.1771 47.5728 33.3543 47.5728 33.4164 43.1543C33.3543 38.7396 40.1771 38.7396 40.115 43.1543Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5665 41.2944C40.5161 44.9035 35.3808 47.0718 33.4961 43.9344C34.8256 49.0026 42.262 45.7872 39.5665 41.2944Z",
    fill: "#FF7D23"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5782 45.0445C44.644 49.4629 37.8175 49.4629 37.8833 45.0445C37.8175 40.6297 44.644 40.6297 44.5782 45.0445Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0338 43.1841C44.9798 46.7931 39.8444 48.9652 37.9707 45.824C39.2929 50.896 46.7329 47.6805 44.0338 43.1841Z",
    fill: "#FF7D23"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2385 48.2079C44.2932 52.0471 38.358 52.0471 38.4164 48.2079C38.3617 44.3649 44.2932 44.3649 44.2385 48.2079Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7637 46.5889C44.5855 49.7263 40.1112 51.6125 38.4932 48.8835C39.64 53.2908 46.1122 50.4949 43.7637 46.5889Z",
    fill: "#FF7D23"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4816 42.1892C42.5364 46.0284 36.6048 46.0284 36.6596 42.1892C36.6048 38.3425 42.54 38.3425 42.4816 42.1892Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0068 40.5664C42.8323 43.7039 38.3544 45.5901 36.7363 42.861C37.8795 47.2684 44.3553 44.4725 42.0068 40.5664Z",
    fill: "#FF7D23"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8995 41.2906C35.9543 45.1298 30.0227 45.1298 30.0775 41.2906C30.0227 37.4513 35.9543 37.4513 35.8995 41.2906Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4248 39.6719C36.2502 42.8131 31.7723 44.6993 30.1543 41.9702C31.3048 46.3775 37.7733 43.5817 35.4248 39.6719Z",
    fill: "#FF7D23"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5559 48.2597C39.6253 53.1683 32.0428 53.1683 32.1159 48.2597C32.0355 43.3548 39.6253 43.3548 39.5559 48.2597Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M38.95 46.1919C40.0019 50.2019 34.2967 52.6154 32.2148 49.1252C33.6831 54.7578 41.9523 51.1859 38.95 46.1919Z",
    fill: "#FF7D23"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6481 45.8018C35.6262 51.2413 27.4885 51.2413 27.463 45.8018C27.4374 40.3623 35.6262 40.3623 35.6481 45.8018Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9831 43.5259C36.1409 47.9406 29.8697 50.5806 27.5723 46.7525C29.1867 52.9569 38.2849 49.0211 34.9831 43.5259Z",
    fill: "#FF7D23"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1011 43.459L57.9096 52.3665L55.9629 54.5942L60.1011 43.459Z",
    fill: "#A7163E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5088 60.2861L60.2618 67.9238L58.0703 69.4572L63.5088 60.2861Z",
    fill: "#A7163E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3557 56.1834C68.4215 60.6798 61.4709 60.6798 61.5366 56.1834C61.4745 51.6869 68.4215 51.6869 68.3557 56.1834Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8006 54.29C68.7648 57.9659 63.5382 60.1714 61.6279 56.9782C62.972 62.1393 70.5509 58.8644 67.8006 54.29Z",
    fill: "#FF7D23"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5553 61.3257C72.6101 65.2355 66.5689 65.2355 66.6274 61.3257C66.5689 57.4123 72.6101 57.4123 72.5553 61.3257Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0696 59.6772C72.9096 62.8741 68.366 64.7937 66.7041 62.0164C67.8729 66.5054 74.4619 63.6576 72.0696 59.6772Z",
    fill: "#FF7D23"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9635 58.2478C76.0183 62.1575 69.9771 62.1575 70.0356 58.2478C69.9808 54.338 76.022 54.338 75.9635 58.2478Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4992 56.5991C76.3357 59.7923 71.792 61.7156 70.1338 58.9346C71.2843 63.4236 77.8733 60.5757 75.4992 56.5991Z",
    fill: "#FF7D23"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7889 61.3816C67.7633 66.4201 60.2319 66.4164 60.21 61.3816C60.1881 56.3468 67.7669 56.3468 67.7889 61.3816Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1718 59.269C68.242 63.3533 62.4236 65.8076 60.3125 62.2394C61.8064 67.9983 70.2253 64.3633 67.1718 59.269Z",
    fill: "#FF7D23"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8115 58.8974C63.7859 64.4372 55.4985 64.4372 55.4766 58.8974C55.4547 53.3576 63.7859 53.3279 63.8115 58.8974Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1329 56.562C64.309 61.0547 57.9208 63.7541 55.5869 59.848C57.2378 66.1564 66.4931 62.1575 63.1329 56.562Z",
    fill: "#FF7D23"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9534 57.3381C72.0118 61.337 65.8355 61.337 65.894 57.3381C65.8355 53.3281 72.0118 53.3281 71.9534 57.3381Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4601 55.6562C72.3185 58.92 67.6725 60.8841 65.9814 58.0437C67.1685 62.633 73.9073 59.722 71.4601 55.6562Z",
    fill: "#FF7D23"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7363 31.3359C46.8719 37.5738 45.2027 36.0069 51.7589 45.9911L51.3535 50.8811L44.779 38.0156L36.7363 31.3359Z",
    fill: "#A7163E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2488 27.523C39.2232 32.8882 31.2134 32.8882 31.1769 27.523C31.1404 22.1577 39.2232 22.1577 39.2488 27.523Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6096 25.2803C39.7492 29.6319 33.5619 32.2458 31.3047 28.4623C32.8752 34.5739 41.8457 30.6975 38.6096 25.2803Z",
    fill: "#FF7D23"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2197 33.6122C44.2854 38.2386 37.1339 38.2386 37.1997 33.6122C37.1485 28.9821 44.2854 28.9821 44.2197 33.6122Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6465 31.6592C44.64 35.4427 39.2599 37.7336 37.2949 34.4291C38.6792 39.7424 46.4772 36.371 43.6465 31.6592Z",
    fill: "#FF7D23"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2559 29.9662C48.3216 34.5926 41.1701 34.5926 41.2359 29.9662C41.1665 25.3361 48.3216 25.3361 48.2559 29.9662Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6827 28.0132C48.6761 31.7967 43.2997 34.0691 41.3311 30.7794C42.7153 36.0927 50.5133 32.725 47.6827 28.0132Z",
    fill: "#FF7D23"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5769 33.6791C38.5477 39.6199 29.6321 39.6199 29.6065 33.6791C29.5809 27.7384 38.5514 27.7086 38.5769 33.6791Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M37.843 31.1841C39.1141 36.011 32.2365 38.9257 29.7236 34.7188C31.4951 41.5099 41.4626 37.2028 37.843 31.1841Z",
    fill: "#FF7D23"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8616 30.7123C33.8324 37.2731 24.0256 37.2731 24 30.7123C24.0292 24.1551 33.8397 24.1551 33.8616 30.7123Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0621 27.9722C34.4573 33.278 26.8931 36.4861 24.1318 31.8597C26.1918 39.3376 36.9702 34.6741 33.0621 27.9722Z",
    fill: "#FF7D23"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5079 28.8891C43.5773 33.6231 36.2651 33.6231 36.3345 28.8891C36.2651 24.1587 43.5773 24.1587 43.5079 28.8891Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M42.923 26.8955C43.9384 30.7644 38.4378 33.0888 36.418 29.7248C37.8424 35.1569 45.8194 31.7113 42.923 26.8955Z",
    fill: "#FF7D23"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3458 24.4077L51.6713 45.2969L50.6084 42.7164L59.8564 24.1626L60.3458 24.4077Z",
    fill: "#A7163E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0747 21.9719L56.28 32.6839L55.2317 35.049L53.7744 21.4409L55.0747 21.9719Z",
    fill: "#A7163E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4798 18.9645C64.4543 24.7902 55.7432 24.7902 55.7139 18.9645C55.6847 13.1389 64.4579 13.1426 64.4798 18.9645Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7681 16.5288C65.0063 21.2517 58.2894 24.0922 55.835 19.9856C57.5662 26.617 67.3037 22.4102 63.7681 16.5288Z",
    fill: "#FF7D23"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3246 21.4411C70.299 27.2631 61.5879 27.2631 61.5587 21.4411C61.5294 15.6191 70.299 15.6154 70.3246 21.4411Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6082 19.0054C70.8464 23.7283 64.1295 26.565 61.6787 22.4585C63.4063 29.0936 73.1438 24.8867 69.6082 19.0054Z",
    fill: "#FF7D23"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8788 25.5734C69.8569 30.6379 62.2817 30.6379 62.2598 25.5734C62.2379 20.5088 69.8569 20.5126 69.8788 25.5734Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2572 23.457C70.3529 27.5636 64.509 30.0327 62.3613 26.4608C63.8625 32.2271 72.3289 28.5698 69.2572 23.457Z",
    fill: "#FF7D23"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7531 25.648C63.7238 32.1197 54.0448 32.116 54.0156 25.648C54.0448 19.1688 63.7238 19.1688 63.7531 25.648Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9572 22.9409C64.3342 28.1874 56.8722 31.3397 54.1475 26.7764C56.1746 34.1542 66.8142 29.5649 62.9572 22.9409Z",
    fill: "#FF7D23"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6397 22.4287C58.6104 29.5651 47.9635 29.5651 47.9307 22.4287C47.9635 15.3109 58.6104 15.3109 58.6397 22.4287Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7669 19.4546C59.2826 25.2246 51.0719 28.6962 48.0732 23.6763C50.2976 31.7929 62.0074 26.7283 57.7669 19.4546Z",
    fill: "#FF7D23"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6687 35.9515C67.6395 42.8985 57.2373 42.8985 57.2373 35.9515C57.2373 29.0045 67.6395 29.0045 67.6687 35.9515Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8173 33.0479C68.2783 38.6805 60.283 42.063 57.3574 37.1656C59.5379 45.0817 70.9555 40.1471 66.8173 33.0479Z",
    fill: "#FF7D23"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9038 42.4343C74.9038 48.6425 65.6339 48.7093 65.5645 42.5012C65.5499 36.293 74.8344 36.2262 74.9038 42.4343Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1262 39.8428C75.4995 44.8664 68.3407 47.9445 65.6963 43.5855C67.6905 50.6476 77.8663 46.1623 74.1262 39.8428Z",
    fill: "#FF7D23"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7996 43.9194C66.7631 51.635 55.2213 51.635 55.1885 43.9194C55.2213 36.2001 66.7668 36.2001 66.7996 43.9194Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8536 40.7041C67.3986 47.0162 58.7167 50.7292 55.3418 45.2674C57.7634 54.0709 70.452 48.5794 65.8536 40.7041Z",
    fill: "#FF7D23"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4877 41.818C59.3416 50.3579 46.8575 50.3579 46.7041 41.818C46.8575 33.2781 59.3453 33.2781 59.4877 41.818Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4467 38.2646C60.1597 45.2302 50.594 49.2848 46.8867 43.3032C49.5457 52.9755 63.5054 46.9419 58.4467 38.2646Z",
    fill: "#FF7D23"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9431 36.4378C72.9139 42.7871 63.4211 42.7833 63.3956 36.4378C63.37 30.0923 72.9431 30.0923 72.9431 36.4378Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1798 33.7832C73.5312 38.9294 66.2117 42.026 63.5381 37.5482C65.525 44.7885 75.9637 40.2735 72.1798 33.7832Z",
    fill: "#FF7D23"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5869 36.2482C60.5577 42.8239 50.7253 42.8239 50.6924 36.2482C50.7216 29.6614 60.5613 29.6614 60.5869 36.2482Z",
    fill: "#FF7D23"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7944 33.4858C61.1933 38.8214 53.6072 42.0257 50.835 37.3882C52.8876 44.8847 63.6989 40.2101 59.7944 33.4858Z",
    fill: "#FF7D23"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_21082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 77,
    fill: "white",
    transform: "translate(24 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTree);
export default __webpack_public_path__ + "static/media/imgTree.f7864cfcc12e41794c94edb020228a27.svg";
export { ForwardRef as ReactComponent };